import getValidQuickValues from './getValidQuickValues'

// 获取查询应用数据，应用数据需要全字段
export default ({ quickItem, fieldsGroup, sortFields }) => {
    const { validSortFields, fullQueryFields } = getValidQuickValues({
        quickItem,
        fieldsGroup,
        sortFields
    })

    // 筛选数据
    const queryValue = fullQueryFields.reduce((t, c) => {
        c.fields.forEach(v => {
            t[v.name] = v.value
        })

        return t
    }, {})

    // 排序数据
    const sortValue = validSortFields && { code: validSortFields.name, order: validSortFields.value }

    return {
        itemKey: quickItem?.key || '',
        queryValue,
        sortValue
    }
}
